import { createRouter, createWebHistory } from 'vue-router';
import Layout from '@/views/Layout'
import Index from '@/views/Index'

const routes = [
  {
    path: '/',
    name: 'index',
    component: Index,
  },
  {
    path: '/mobile',
    component: Layout,
    name: 'mobile',
    children: [
      { path: '', redirect: "/mobile/index" },
      {
        path: "/mobile/index",
        component: () => import('@/views/mobile/Index'),
        name: "Mobileindex",
        meta: { title: "会员卡菜单" }
      }, {
        path: "/mobile/pay",
        component: () => import('@/views/mobile/Pay'),
        name: "Pay",
        meta: { title: "会员卡充值" }
      }
      , {
        path: "/mobile/coupon",
        component: () => import('@/views/mobile/Coupon'),
        name: "Coupon",
        meta: { title: "我的优惠券" }
      }
      , {
        path: "/mobile/activate",
        component: () => import('@/views/mobile/ActivateVipCard'),
        name: "ActivateVipVard",
        meta: { title: "激活会员卡" }
      }
      , {
        path: "/mobile/purchaseHistory",
        component: () => import('@/views/mobile/PurchaseHistory'),
        name: "PurchaseHistory",
        meta: { title: "消费记录" }
      }
      , {
        path: "/mobile/purchaseDetail",
        component: () => import('@/views/mobile/PurchaseDetail'),
        name: "PurchaseDetail",
        meta: { title: "消费记录详情" }
      }
      , {
        path: "/mobile/payList",
        component: () => import('@/views/mobile/PayList'),
        name: "PayList",
        meta: { title: "充值记录" }
      }
      , {
        path: "/mobile/passwordAdmin",
        component: () => import('@/views/mobile/PasswordAdmin'),
        name: "PasswordAdmin",
        meta: { title: "密码管理" }
      }
      , {
        path: "/mobile/myIntegrate",
        component: () => import('@/views/mobile/MyIntegrate'),
        name: "MyIntegrate",
        meta: { title: "我的积分" }
      }
      , {
        path: "/coupon/getCoupon",
        component: () => import('@/views/coupon/GetCoupon'),
        name: "GetCoupon",
        meta: { title: "领取优惠券" }
      }
    ],
  },
  {
    path: '/401',
    name: '401',
    component: () => import('@/views/401'),
    hidden: true,
    meta: { title: "401" }
  },
  {
    path: '/404',
    name: '404',
    component: () => import('@/views/404'),
    hidden: true,
    meta: { title: "404" }
  },
]

// 创建 router 实例
const router = createRouter({
  // history: createWebHashHistory(),
  history: createWebHistory(),
  routes
});
// console.log(VueCookies);
//路由跳转过滤器
router.beforeEach((to, from, next) => {   //注册页面跳转过滤器
  next()
  if (to.meta && to.meta.title) {
    document.title = to.meta.title
  }
})

export default router